import React from 'react';

/**
 * ContentWrapper - A modern replacement for dashboard_data_wrap and dashbord_cont_wrapper
 * 
 * MIGRATION GUIDE:
 * Old pattern:
 *   <div className="dashboard_data_wrap">
 *     <div className="dashbord_cont_wrapper">
 *       <div className="userlist-title-modern">Title</div>
 *       {content}
 *     </div>
 *   </div>
 * 
 * New pattern:
 *   <ContentWrapper title="Title">
 *     {content}
 *   </ContentWrapper>
 * 
 * Props:
 * - title: Optional page title
 * - className: Additional CSS classes
 * - showBackground: Whether to show the white background card (default: true)
 * - children: Page content
 */
export default function ContentWrapper({ 
  children, 
  title, 
  className = "",
  showBackground = true 
}) {
  return (
    <div className={`${showBackground ? 'bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden' : ''} ${className}`}>
      <div className="p-6">
        {title && (
          <div className="text-2xl font-bold text-gray-900 mb-6">
            {title}
          </div>
        )}
        {children}
      </div>
    </div>
  );
}